import { IdlePeriodLegacySettingsFormModel } from 'src/Libs/smart-charge/models'
import { legacyIdlePeriodFormToDto } from 'src/Libs/smart-charge/utils'
import { IdlePeriodsLegacySettingsUpdateDto } from 'src/Libs/smart-charge/dto'

const settingsFormToDtoTransformer = (formValues: IdlePeriodLegacySettingsFormModel): IdlePeriodsLegacySettingsUpdateDto => {
  return {
    emsIdlePeriod: legacyIdlePeriodFormToDto(formValues.emsIdlePeriod),
  } as IdlePeriodsLegacySettingsUpdateDto
}
export default settingsFormToDtoTransformer
